import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class AppInitService {

    constructor(private titleService: Title) { }

    init() {
        this.loadData(window.location.hostname);
    }

    loadData(hostname: string) {
        if (hostname.indexOf('yobing') < 0 && hostname.indexOf('localhost') < 0) {
            this.titleService.setTitle("Classora People - Panel");
            document.getElementById('appIcon')?.setAttribute('href', 'assets/layout/images/test/classora-favicon.ico');
        } else {
            this.titleService.setTitle("Yobing - Panel");
        }
    }
}
